import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { TriggerWelcomeBonusRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { TriggerWelcomeBonusResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const triggerWelcomeBonus = (request: TriggerWelcomeBonusRequest, options?: CashRequestOptions) =>
  post<TriggerWelcomeBonusRequest, TriggerWelcomeBonusResponse>('/2.0/cash/trigger-welcome-bonus', request, {
    ...options,
    rejectOnError: true,
  })
